import { render, staticRenderFns } from "./OrgSelector.vue?vue&type=template&id=8b13f37c"
import script from "./OrgSelector.vue?vue&type=script&lang=js"
export * from "./OrgSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports